<template>
  <ReviewTitle
    :navList="navList"
    :title="title"
    :from="fromPage"
    @bakToPrev="bakToPrev"
  >
    <template v-if="$route.meta.keepAlive">
      <keep-alive>
        <router-view
          @setTitleNav="setTitleNav"
          @setTitleType="setTitleType"
          @setReivewTitle="setReivewTitle"
        ></router-view>
      </keep-alive>
    </template>
    <template v-else>
      <router-view
        @setTitleNav="setTitleNav"
        @setTitleType="setTitleType"
        @setReivewTitle="setReivewTitle"
      ></router-view>
    </template>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </ReviewTitle>
</template>
<script>
import ReviewTitle from "@/components/StudyCenter/ReviewTitle";
import PopTips from "@/components/popTips";

export default {
  name: "review-home",
  data() {
    return {
      title: "",
      fromPage: "",
      navList: [],
      dialogVisable: false,
      popTipsCont: {
        title: this.$t("Common.tips"),
        context: this.$t("blendType.isQuit"),
        btns: [
          {
            text: this.$t("Common.quit"),
            event: "handConfirm",
          },
          {
            text: this.$t("Common.think"),
            event: "handleCloseTip",
          },
        ],
      },
    };
  },
  components: {
    ReviewTitle,
    PopTips,
  },
  methods: {
    handConfirm() {
      if (this.$route.query.from == "taskcenter") {
        this.$router.push({
          path: "/TaskCenter",
        });
      } else if (this.$route.query.from == "review") {
        this.$router.go(-1);
      } else {
        this.$router.go(-1);
      }
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      // console.log("bakToPrev");
      // this.$router.go(-1)
      this.dialogVisable = true;
    },
    getData() {
      console.log("getData");
    },
    setReivewTitle(v) {
      this.title = v;
    },
    setTitleType(v) {
      this.fromPage = v;
    },
    setTitleNav(v) {
      console.log(v, "vvvvvv");

      this.navList = v;
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from.path == '/ReviewMaps', 'from.path == /ReviewMaps')
    if (from.path == '/ReviewMaps') {
      from.meta.canUpdate = true
    }
    next()
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      console.log(this.$eventBus.$on("title"), "ononasdasdasdasdasdasd");
    },
  },
};
</script>